module.exports = __webpack_public_path__ + "static/img/m_name.2b8f425.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/tysdags/m_name.png
// module id = 9kpz
// module chunks = 7